import { defaultZetachainProviderConfiguration } from '../default-constants';

export const SUSHI_SWAP_ZETACHAIN_CONTRACT_ADDRESS = '0x1f2FCf1d036b375b384012e61D3AA33F8C256bbE';

export const SUSHI_SWAP_ZETACHAIN_PROVIDER_CONFIGURATION = defaultZetachainProviderConfiguration;
